export function fetchComponentScript({ baseUrl, name, version, scriptName }: FetchComponentScriptArgs) {
    const path = `${baseUrl}/${name}/${version}/${scriptName}`;
    return fetch(path).then((resp) => resp.text());
}
type FetchComponentScriptArgs = {
    baseUrl: string;
    name: string;
    version: string;
    scriptName: string;
};
